import { Capacitor } from '@capacitor/core';

let listenersReady = false;
let currentUserId = "";

export async function initPushNotifications(userId: string) {
  if (!Capacitor.isNativePlatform()) return;
  currentUserId = userId;

  const { PushNotifications } = await import('@capacitor/push-notifications');

  if (!listenersReady) {
  listenersReady = true;

  PushNotifications.addListener('registration', async (token) => {
    console.log('FCM Token:', token.value);
    const { supabase } = await import('./supabase');
    await supabase.from('profiles').update({ fcm_token: token.value }).eq('id', currentUserId);
  });

  PushNotifications.addListener('registrationError', (error) => {
    console.error('Erro no registro push:', error);
  });

  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Notificação recebida:', notification);
  });

  // Ao tocar na notificacao: abre a pagina indicada pelo servidor (relatorio, fila de aprovacao, conversa...)
  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    const link = action.notification?.data?.link;
    if (typeof link === 'string' && link.startsWith('/') && !link.startsWith('//')) {
      window.location.assign(link);
    }
  });
  }

  const { receive } = await PushNotifications.checkPermissions();

  if (receive === 'prompt') {
    const { receive: granted } = await PushNotifications.requestPermissions();
    if (granted !== 'granted') return;
  } else if (receive !== 'granted') {
    return;
  }

  await PushNotifications.register();
}
